import React, { FC, useMemo, useRef, useState } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Lookup,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CreateEditModal, DeleteModal } from './components';

const EmployeesSalary: FC = () => {
  const [id, setId] = useState<number | null>(null);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);

  const employeeSalaryConfiguration: any = useMemo(() => {
    return $createStore('/v1/EmployeeSalary/Configuration/', 'id');
  }, []);

  const salaryTypes = useMemo(() => {
    return $createStore('/v1/EmployeeSalary/types', 'id');
  }, []);

  const additionalPaymentTypes: any = useMemo(() => {
    return $createStore('/v1/EmployeeSalary/additionalPaymentTypes', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);
  const refreshGrid = () => refGrid.current?.instance.refresh();

  return (
    <div className="container-dev">
      <AppLayoutTop title="Настройка зарплаты окладников">
        <ClaimsProvider claimsBlock={['CanEditSalaryFixedConfigurationSection']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setId(null);
              setVisibleModal(true);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>
      {visibleModal && (
        <CreateEditModal changeVisible={setVisibleModal} id={id} refresh={refreshGrid} visible={visibleModal} />
      )}

      <DeleteModal changeVisible={setVisibleDeleteModal} id={id} refresh={refreshGrid} visible={visibleDeleteModal} />
      <AppCard>
        <DataGrid
          dataSource={employeeSalaryConfiguration}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          remoteOperations
        >
          <StateStoring enabled={true} type="localStorage" storageKey="EmployeesSalaryStore" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />

          <Column dataField="employeeName" caption="ФИО сотрудника" />
          <Column dataField="post" caption="Должность" />
          <Column dataField="salaryType" caption="Расчет">
            <Lookup dataSource={salaryTypes} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="salary" caption="Оклад" />
          <Column dataField="dateBegin" dataType="date" caption="Дата начала" width={120} />
          <Column dataField="dateEnd" dataType="date" caption="Дата окончания" width={120} />
          <Column dataField="additionalPaymentType" caption="Тип доп, выплаты">
            <Lookup dataSource={additionalPaymentTypes} valueExpr="id" displayExpr="name" />
          </Column>
          <Column dataField="additionalPayment" caption="Сумма доп, выплаты" />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField=""
            cellRender={({ data }) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditSalaryFixedConfigurationSection']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setId(data.id);
                      setVisibleModal(true);
                    }}
                  />
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setVisibleDeleteModal(true);
                      setId(data.id);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default EmployeesSalary;
